// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import classNames from '@ta/common.classnames';
import { Impression } from '@ta/common.tracking';
import { localize } from '@ta/common.i18n';
import { Icon } from '@ta/styleguide.icon';

import FeaturedDestinationData from './FeaturedDestinationsData';

import styles from './FeaturedDestinations.less';
import DestinationCard from './DestinationCard';

type ExternalProps = {|
  sponsoredLimit?: number,
  totalLimit?: number,
|};

type Props = {|
  ...ExternalProps,
  uid: string,
  geoId: number,
|};

const FeaturedDestinations = ({ uid, geoId, sponsoredLimit = 1, totalLimit = 3 }: Props) => (
  <FeaturedDestinationData>
    {featuredDestinations => {
      const sponsoredDestinations = featuredDestinations
        .filter(d => d.sponsor)
        .slice(0, sponsoredLimit);
      const nonSponsoredDestinations = featuredDestinations
        .filter(d => !d.sponsor)
        .slice(0, totalLimit - sponsoredDestinations.length);
      const allDestinations = sponsoredDestinations.concat(nonSponsoredDestinations);

      // Create a structed object array for Impressions
      const sections = allDestinations.map(({ destination, sponsor }) => ({
        locationId: destination.locationId,
        ...(sponsor && { sponsoredBy: sponsor.id }),
      }));

      return (
        <div className={classNames('ui_card', styles.section)}>
          <div className={styles.header_and_icon}>
            <Icon name="travelers-choice-badge" className={styles.tcLogo} />
            <div className={classNames('ui_header h3', styles.header)}>
              {/*  Featured destinations */}
              {localize('Featured_destinations')}
            </div>
          </div>
          <div className={styles.destination_candidates}>
            <Impression
              source="homeRightRailFeaturedDestinations"
              attributes={{
                homeRightRailFeaturedDestinations: {
                  uid,
                  scopedGeoId: geoId,
                  sections,
                },
              }}
            >
              {allDestinations.map((destination, index) => (
                <DestinationCard
                  key={destination.destination.locationId}
                  slot={index}
                  destinationData={destination.destination}
                  destinationSponsor={destination.sponsor}
                />
              ))}
            </Impression>
          </div>
        </div>
      );
    }}
  </FeaturedDestinationData>
);

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  uid: state.tracking.uid || '',
  geoId: state.route.geo || 1,
}))(FeaturedDestinations);
